import { useState, useEffect, useRef, useCallback } from 'react';
import "./MenuSection.css";
import menuData from './menuData';

const MenuSection = () => {
    const [activeTab, setActiveTab] = useState('All');
    const itemRefs = useRef([]);
    const [expandedItems, setExpandedItems] = useState({});
    const toggleDescription = (index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    const truncateDescription = (text, index) => {
        const words = text.split(' ');
        const isExpanded = expandedItems[index];

        if (words.length <= 10 || isExpanded) {
            return (
                <>
                    {text}
                    {words.length > 10 && (
                        <span
                            className=" ms-1 cursor-pointer read-toggle "
                            onClick={() => toggleDescription(index)}
                        >
                            Read less
                        </span>
                    )}
                </>
            );
        } else {
            return (
                <>
                    {words.slice(0, 10).join(' ')}...
                    <span
                        className=" ms-1 cursor-pointer read-toggle "
                        onClick={() => toggleDescription(index)}
                    >
                        Read more
                    </span>
                </>
            );
        }
    };
    const getFilteredItems = useCallback(() => {
        if (activeTab === 'All') {
            return Object.keys(menuData).reduce((acc, key) => [...acc, ...menuData[key]], []);
        }
        return menuData[activeTab] || [];
    }, [activeTab]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('reveal');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2 }
        );

        const filtered = getFilteredItems();
        itemRefs.current = itemRefs.current.slice(0, filtered.length);

        itemRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, [getFilteredItems]);

    const categories = ['All', ...Object.keys(menuData)];
    const filteredItems = getFilteredItems();
    itemRefs.current = new Array(filteredItems.length);

    function getAllPrices(item) {
        const priceKeys = Object.keys(item).filter(key => {
        const lowerKey = key.toLowerCase();
            return lowerKey.includes('price') || lowerKey === 'onepiece';
        });

        return priceKeys.map(key => {
            let label = '';
            switch (key.toLowerCase()) {
                case 'smallprice': label = 'Small'; break;
                case 'largeprice': label = 'Large'; break;
                case 'onepiece': label = '1"'; break;
                case 'threeprice': label = '3"'; break;
                case 'fouprice': label = '4"'; break;
                case 'sixprice': label = '6"'; break;
                case 'eightprice': label = '8"'; break;
                case 'nineprice': label = '9"'; break;
                case 'tenprice': label = '10"'; break;
                case 'twelveprice': label = '12"'; break;
                case 'sixteenprice': label = '16"'; break;
                default:
                    const numMatch = key.match(/\d+/);
                    label = numMatch ? `${numMatch[0]}"` : '';
            }
            return (
                <div key={key} className='me-2 d-inline-flex align-items-center gap-1 flex-wrap'>
                    <p className='m-0 fs-13 fw-500'>
                        {label ? `${label} -  ` : ''}
                    </p>
                    <p className=' m-0 menu-item-price'> {item[key]}</p>
                </div>
            );
        });
    }



    return (
        <section className="menu_section">
            <h1 className="menu-title mt-3 mb-0 text-center">Our Menu</h1>
            <p className="menu-subtitle">
                We consider all the drivers of change gives you the components you need to change to create a truly happens.
            </p>
            <div className="menu-padding px-xl-5">
                <div className="menu-tabs">
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`tab ${activeTab === category ? 'active' : ''}`}
                            onClick={() => setActiveTab(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>
                <hr className='pb-24' />
                <div className="row w-100 justify-content-center">
                    {filteredItems.map((item, index) => (
                        <div className="col-xl-4 col-sm-6 col-12 d-flex" key={index}>
                            <div className="menu-item" ref={(el) => (itemRefs.current[index] = el)}>
                                <div className="menu-item-image-container">
                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="menu-item-image"
                                        onError={(e) => (e.target.src = 'https://placehold.co/150x150')}
                                    />
                                </div>
                                <div>
                                    <h3 className="menu-item-name">{item.name}</h3>
                                    <div >{getAllPrices(item)}</div>

                                    <div className="details-description">
                                        {truncateDescription(item.description, index)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MenuSection;
